import logger from '3-foundation/Logging/logger';
import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstLink } from '../DataTypes/linkMapper';
import { mapFirstTheme } from '../DataTypes/themeMapper';

export const mapContentCard = ({ content, settings }): Content.ContentCard => {
	try {
		return {
			documentType: content?.contentType,
			content: {
				properties: {
					kicker: content?.properties?.kicker ?? null,
					altText: content?.properties?.altText ?? null,
					heading: content?.properties?.heading ?? null,
					text: content?.properties?.text?.markup ?? null,
					link: mapFirstLink(content?.properties?.link),
					image: mapFirstImage(content?.properties?.image),
				},
			},
			settings: {
				properties: {
					...settings.properties,
					orientation: settings?.properties?.orientation ? settings.properties.orientation : 'Horizontal', // Horizontal is default value for ContentCard Block
					theme: mapFirstTheme(settings?.properties?.theme),
				},
			},
		};
	} catch (e) {
		logger.error(`Could not map ContentCard \nCause: ${e}`);
		throw new Error(`Could not map ContentCard \nCause: ${e}`, e);
	}
};
